/**
 * @Author: Calvin Green <calvin>
 * @Date:   2022-03-01T13:12:28+02:00
 * @Email:  calvin@diversitude.com
 * @Last modified by:   calvin
 * @Last modified time: 2022-06-09T16:42:22+02:00
 * @Copyright: Diversitude 2022
 */



//eslint-disable-next-line
import axios from "axios";

const base = process.env.VUE_APP_API_BASEURL;

export const state = {
    core_data: null,
    user_levels: null,
    level_types: null,
    users_in_level: null,
    all_users: null,
    level_id: null,
    user_profile: null,
    audit_logs: null,
};

export const getters = {
    coreLoaded(state) {
        if (state.core_data != null) {
            return true;
        }
        return false;
    },
    userType(state) {
        if (state.core_data != null) {
            if(state.core_data.ccb_admin){
                return 'admin';
            }
            else if(state.core_data.client_admin){
                return 'client_admin';
            }
            else{
                return 'client'
            }
        }
        else{
            return '';
        }

    },
}

export const mutations = {
    setCoreData(state, payload){
        let core = payload;
        //core.client_admin = false;
        state.core_data = core;
    },
    setLevels(state, payload){
        state.user_levels = payload;
    },
    setLevelTypes(state, payload){
        state.level_types = payload;
    },
    setAllLevelUsers(state, payload){
        state.all_users = payload;
    },
    setLevelUsers(state, payload){
        state.users_in_level = payload;
    },
    setSelectedID(state, payload){
        state.level_id = payload;
    },
    setProfileData(state, payload){
        state.user_profile = payload;
    },
    setAuditLogs(state, payload){
        state.audit_logs = payload;
    },
    resetStore(state, payload){
        state.core_data = payload;
        state.user_levels = payload;
        state.users_in_level = payload;
        state.all_users = payload;
        state.level_id = payload;
        state.user_profile = payload;
    }
};

export const actions = {
    loadCoreData({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/auth/core')
            .then((response)=>{
                console.log('Core Data', response.data);
                commit('setCoreData', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },
    clearCoreData({commit}){
        commit('setCoreData', null);
    },
    loadAuditLogs({commit}){
        return new Promise((resolve, reject) => {
            window.axios.get(`api/clientadmin/auditlogs`)
            .then( (response) =>{
                commit('setAuditLogs', response.data)
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    loadLevelTypes({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/clientadmin/leveltypes')
            .then((response)=>{
                commit('setLevelTypes', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },
    loadLevels({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/clientadmin/levels')
            .then((response)=>{
                console.log('Levels Data', response.data);
                commit('setLevels', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },
    loadLevelUsers({commit}, level_id){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/clientadmin/levelusers/' + level_id)
            .then((response) => {
                if(level_id == 0 || level_id == -1){
                    commit('setAllLevelUsers', response.data);
                }
                else{
                    commit('setLevelUsers', response.data);
                    commit('setSelectedID', level_id);
                }
                resolve();
            })
            .catch((e)=>{
                reject(e);
            })
        })
    },
    clearLevelUsers({commit}){
        commit('setLevelUsers', null);
    },
    //eslint-disable-next-line
    deleteUser({}, params) {
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/clientadmin/deleteuser', params)
            .then((response)=>{
                resolve(response.data);
            })
            .catch((e) => {
                reject(e);
            })
        });
    },
    //eslint-disable-next-line
    saveUserToLevel({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/clientadmin/saveleveluser', params)
            .then((response)=>{
                resolve(response.data);
            })
            .catch((e) => {
                reject(e);
            })
        });
    },
    //eslint-disable-next-line
    resetUserCredentials({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/clientadmin/reset_user', params)
            .then((response)=>{
                resolve(response.data);
            })
            .catch((e) => {
                reject(e);
            })
        });
    },
    /*eslint-disable-next-line */
    addUserToSelectedLevel({dispatch}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/clientadmin/addusertolevel', params)
            .then(()=>{
                dispatch('loadLevelUsers', 0)
                .then(()=>{
                    resolve();
                })
            })
            .catch((e) => {
                reject(e);
            })
        })
    },
    /*eslint-disable-next-line */
    removeUserFromSelectedLevel({dispatch}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/clientadmin/removefromlevel', params)
            .then(()=>{
                dispatch('loadLevelUsers', 0)
                .then(()=>{
                    resolve();
                })
            })
            .catch((e) => {
                console.log(e);
                reject();
            })
        })
    },


    //eslint-disable-next-line
    saveLevelLead({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/clientadmin/setlevellead', params)
            .then(()=>{
                resolve();
            })
            .catch((e) => {
                console.log(e);
                reject();
            })
        })
    },


    //eslint-disable-next-line
    saveLevel({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/clientadmin/savelevel', params)
            .then(()=>{
                resolve();
            })
            .catch((e) => {
                console.log(e);
                reject();
            })
        })
    },
    //eslint-disable-next-line
    deleteLevel({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/clientadmin/deletelevel', params)
            .then( response => {
                console.log(response);
                resolve();
            })
            .catch( error => {
                reject(error.response.data.message);
            })
        })
    },
    //eslint-disable-next-line
    downloadPersonnelDocument({}, params){ //{ jwt, user_id, type}
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/clientadmin/downloadpersonneldoc/' + params.jwt + '/' + params.user_id + '/' + params.type)
            .then((response) => {
                resolve(response.data);
            })
            .catch((e)=>{
                console.log(e);
                reject();
            })
        })
    },
    //eslint-disable-next-line
    downloadPersonnelDocuments({}, params){ //{ jwt, user_id}
        return new Promise((resolve, reject)=>{
            window.axios.get('api/clientadmin/downloadpersonneldoc/' + params.jwt + '/' + params.user_id)
            .then((response) => {
                resolve(response);
            })
            .catch((e)=>{
                console.log(e);
                reject();
            })
        })
    },
    //eslint-disable-next-line
    getLoggedInUserProfile({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/clientuser/userprofile')
            .then((response) => {
                commit('setProfileData', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e);
                reject();
            })
        })
    },
    //eslint-disable-next-line
    requestSopDistribution({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/clientuser/requestsopdist', params)
            .then(()=>{
                resolve();
            })
            .catch((e) => {
                console.log(e);
                reject();
            })
        })
    },
    clearAll({commit}){
        return new Promise((resolve) => {
            commit('resetStore', null);
            resolve();
        })
    },
};
